import { getDecimalPlacesCount } from "helpers/math";

export default (odds: number, minDecimalPlaces: number) => {
  return getDecimalPlacesCount(odds) < minDecimalPlaces ? odds.toFixed(minDecimalPlaces) : String(odds);
  // please check: maybe we need to return only  odds.toFixed(MIN_DECIMAL_PLACES)
  // getDecimalPlacesCount(odds) < MIN_DECIMAL_PLACES < or > in this condition ????  for example for some skins we have
  // "remove3Digit" config and 1.0001 should be 1.00 and it became block
};
